import React from "react";

export const getStoreNameParts = (storeName) => {
  const displayName = (storeName || "").toString().trim().replace(/\s+/g, " ");
  if (!displayName) return [];

  return displayName
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Za-z])([0-9])/g, "$1 $2")
    .replace(/([0-9])([A-Za-z])/g, "$1 $2")
    .split(/\s+/)
    .filter(Boolean);
};

const StoreName = ({ name, className = "", wrapperClassName = "" }) => {
  const parts = getStoreNameParts(name);
  if (!parts.length) return null;

  const wrapperClasses = [
    "inline-flex",
    "flex-wrap",
    "justify-end",
    "items-baseline",
    "max-w-full",
    "min-w-0",
    "leading-[1.15]",
    "align-baseline",
    "whitespace-normal",
    wrapperClassName,
  ].filter(Boolean).join(" ");
  const partClasses = [
    "inline-block",
    "max-w-full",
    "min-w-0",
    "[overflow-wrap:anywhere]",
    "break-normal",
    "whitespace-normal",
    className,
  ].filter(Boolean).join(" ");

  return (
    <span className={wrapperClasses} title={name}>
      {parts.map((part, index) => (
        <span
          key={`${part}-${index}`}
          className={partClasses}
        >
          {part}
        </span>
      ))}
    </span>
  );
};

export default StoreName;
